/**
 * Created by Ning Jiang on 2021-06-03.
 */

import {SymbolStack} from "../../core/reel/stackedsymbol/StackedSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipCharacterSymbol} from "./DeadwoodRipCharacterSymbol";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";

export class DeadwoodRipStackedSymbol extends DeadwoodRipCharacterSymbol {

    protected _ripAssetName:string = "xRip_2";

    private _stack:SymbolStack | null;
    public get stack():SymbolStack | null {
        return this._stack;
    }

    public set stack(value:SymbolStack | null) {
        if(this._stack || value == null) {
            debugger;
            throw new Error("DeadwoodRipStackedSymbol.set stack():Cannot change stack!");
        }

        this._stack = value;
        this._stack!.addSymbol(this);
    }

    public get actualSymbolHeight():number {
        return this.symbolHeight * this.stackedSymbolName.totalNum;
    }

    constructor(symbolName:string, reelId:number, initState:DeadwoodRipSymbolState) {
        super(symbolName, reelId, initState);
    }

    protected getCenterPosition():PIXI.Point {
        return new PIXI.Point(0,
            (this.stackedSymbolName.totalNum * this.symbolStep - this.bottomPadding) * 0.5 - (this.stackedSymbolName.index * this.symbolStep + this.symbolHeight * 0.5)
        );
    }

    protected getStateTexture(state?:DeadwoodRipSymbolState):PIXI.Texture[] {
        // if WXN is the stacked symbol with different looks on different reels, then this will make the WXN on reel 1 to load image WXN1/WXN1.png
        let texturePath = `${this.stackedSymbolName.symName}/${this.stackedSymbolName.symName}`;
        if(this.symbolSize > 1) {
            texturePath += `_S${this.symbolSize}`;
        }
        if(state === DeadwoodRipSymbolState.SPIN) {
            texturePath += `_${state}`;
        }

        return DeadwoodRip.assetLoader.getTextures(texturePath);
    }

    public onRemove() {
        if(this._stack) {
            this._stack.removeSymbol(this);
            this._stack = null;
        }
        super.onRemove();
    }

    protected playKillSound():void {
        DeadwoodRipSound.playSymbolKill(this.symbolName.slice(0, 2), this.reelId);
    }
}